import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ChatContainer } from '../../components/chat';
import { startDirectMessage } from '../../services/chatServices';
import { Tour } from '../../components/common/Tour';

const ChatPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const channelIdFromUrl = searchParams.get('channel');
  const matchIdFromUrl = searchParams.get('matchId');
  const otherUserIdFromUrl = searchParams.get('otherUserId');
  // Optional: a conversation starter chosen via "Use in chat" on a match card.
  const prefillFromUrl = searchParams.get('prefill') || undefined;
  const iceBreakerMatchId = searchParams.get('iceBreakerMatchId');
  const iceBreakerIndexRaw = searchParams.get('iceBreakerIndex');
  const iceBreaker =
    iceBreakerMatchId && iceBreakerIndexRaw !== null
      ? { matchId: iceBreakerMatchId, index: Number(iceBreakerIndexRaw) }
      : undefined;
  const [conversationId, setConversationId] = useState<string | null>(channelIdFromUrl);

  // Handle creating/finding a conversation when matchId and otherUserId are provided
  useEffect(() => {
    if (!matchIdFromUrl || !otherUserIdFromUrl || conversationId) return;

    startDirectMessage(otherUserIdFromUrl, matchIdFromUrl)
      .then((convId) => {
        setConversationId(convId);
        setSearchParams({ channel: convId }, { replace: true });
      })
      .catch((error) => {
        console.error('[Chat] Failed to create conversation:', error);
      });
  }, [matchIdFromUrl, otherUserIdFromUrl, conversationId, setSearchParams]);

  return (
    <div className='w-full h-[calc(100vh-80px)] flex'>
      <Tour name='chat' />
      <ChatContainer
        channelIdFromUrl={conversationId}
        prefillText={prefillFromUrl}
        iceBreaker={iceBreaker}
      />
    </div>
  );
};

export default ChatPage;
